import { render, staticRenderFns } from "./SCommercialLottery.vue?vue&type=template&id=8006b3c0&scoped=true"
import script from "./SCommercialLottery.vue?vue&type=script&lang=js"
export * from "./SCommercialLottery.vue?vue&type=script&lang=js"
import style0 from "./SCommercialLottery.vue?vue&type=style&index=0&id=8006b3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8006b3c0",
  null
  
)

export default component.exports